export const Scope = {
    UNLIMITED: 0,
    LIMIT: 1,
};
